import { Table } from "@/component-create/Table";
import { 
  createTableActionItem,
  createTableColumn, 
  createTableColumnSlot, 
  tableAddHeader, 
  tableDeleteController, 
  tableDeleteHeader, 
  tableEditController, 
  tableEditHeader 
} from "@/component-create/utils/create-table-column";
import { ElDivider, ElLoading, ElPopover, ElSwitch, ElTag } from "element-plus";
import { h, ref, Ref } from 'vue'
import CronParser from 'cron-parser'
import Moment from 'moment'
import { JOB_PAGE_URL, remove, state, trigger, updateStatus } from "@/api/system/job";
import { JOB_LOG_STRATEGY, JOB_RUN_RESULT, JOB_RUN_STATE, JOB_STATUS } from "@/constant/system/code";
import JobCssModule from './job.module.scss'
import { deleteBox, toast, warningBox } from "@/utils/message";
import { isOnlyOne } from "@/utils/common";
import { FormDialog } from "@/component-create/FormDialog";
import CommonDialog from "@/component-create/utils/common-dialog";

const Popover = ElPopover as any

let tb: Table
let searchData: Ref<any>;
let editForm: FormDialog
let addForm: FormDialog
let jobName: Ref<string>
let logDialog: CommonDialog

const runStateEl = ref()

const runState = ref({
  refreshing: false,
  showing: false,
  currentJob: null as any,
  state: {
    runState: '',
    latestStartRunTime: '',
    scheduledNextRunTime: '',
    latestExecutionLog: {
      startRunTime: '',
      endRunTime: '',
      runResult: ''
    }
  }
})

/**
 * 
 * @param el 节点
 * @param sdata 搜索表单数据
 * @param ef 编辑表单实例
 * @param af 新增表单实例
 * @param name 任务日志名称
 * @param ld 任务日志对话框实例
 * @returns 
 */
export function renderJobTable(
  el: Element, 
  sdata: Ref<any>, 
  ef: FormDialog, 
  af: FormDialog, 
  name: Ref<string>,
  ld: any
) {
  tb = new Table(
    el, 
    column, 
    headerButtons, 
    { border: true }, 
    JOB_PAGE_URL, 
    { 
      showIndex: true,
      selectable: true
    }
  )
  searchData = sdata
  editForm = ef
  addForm = af
  logDialog = ld

  editForm.onSaveSuccess = () => {
    tb.load(searchData.value)
  }

  addForm.onSaveSuccess = () => {
    tb.load(searchData.value)
  }

  jobName = name

  return tb
}

const column = [
  createTableColumn('任务名称', 'jobName'),
  createTableColumn('任务分组', 'jobGroup'),
  createTableColumn('任务执行器', 'jobExecutor'),
  createTableColumn('执行参数', 'executionParams', undefined, undefined, { showOverflowTooltip: true }),
  createTableColumnSlot(
    '计划执行表达式', 
    (row) => h(
      <ElPopover 
        v-model={ row.showNextScheduleTime } 
        title="下次计划执行时间" 
        trigger="hover" 
        v-slots={{
          reference: () => (
            <div onMouseover={() => { row.showNextScheduleTime = true }} onMouseout={() => { row.showNextScheduleTime = false }}>
              { row.scheduleExpression }
            </div>
          )
        }}
        placement="top">
          { getNextSchedule(row.scheduleExpression) }
      </ElPopover>
    ),
    {
      width: '140',
      align: 'center',
    }
  ),
  createTableColumnSlot(
    '日志策略',
    (row) => {
      if(row.logStrategy === JOB_LOG_STRATEGY.DISABLED.CODE) {
        return h(
          <ElTag type="danger" size="large">
            { JOB_LOG_STRATEGY.DISABLED.SHORT_NAME }
          </ElTag>
        )
      } else if(row.logStrategy === JOB_LOG_STRATEGY.ALL.CODE) {
        return h(
          <ElTag type="success" size="large">
            { JOB_LOG_STRATEGY.ALL.SHORT_NAME }
          </ElTag>
        )
      } else if(row.logStrategy === JOB_LOG_STRATEGY.ERROR.CODE) {
        return h(
          <ElTag type="warning" size="large">
            { JOB_LOG_STRATEGY.ERROR.SHORT_NAME }
          </ElTag>
        )
      }
      return <div></div>
    },
    {
      width: '100',
      align: 'center',
    }
  ),
  createTableColumnSlot(
    '运行状态', 
    row => h(
      <Popover
        title="运行状态" 
        width="280"
        placement="left"
        onShow={ () => { handleRunStateShow(row) } }
        v-slots={{
          reference: () => {
            if(row.runState === JOB_RUN_STATE.RUNNING.CODE) {
              return <ElTag type="success" size="large">{ JOB_RUN_STATE.RUNNING.NAME }</ElTag>
            } else if(row.runState === JOB_RUN_STATE.PENDING.CODE) {
              return <ElTag size="large">{ JOB_RUN_STATE.PENDING.NAME }</ElTag>
            } else if(row.runState === JOB_RUN_STATE.STOPPED.CODE) {
              return <ElTag type="danger" size="large">{ JOB_RUN_STATE.STOPPED.NAME }</ElTag>
            }
          }
        }}
      >
        <div ref={runStateEl}>
          <div>
            {
              renderRunState(runState.value)
            }
          </div>
          <ElDivider content-position="center" class={ JobCssModule.runStateDivider }>上次运行记录</ElDivider>
          <div>
            <div class={ JobCssModule.runStateList }>
              <span class={ JobCssModule.runStateTitle }> 运行结果</span>
              <span style={{ 
                color: 
                  runState.value.state?.latestExecutionLog?.runResult === JOB_RUN_RESULT.SUCCESS.CODE ? 
                  'limegreen' : 
                  [JOB_RUN_RESULT.ERROR.CODE, JOB_RUN_RESULT.FAILED.CODE].includes(runState.value.state?.latestExecutionLog?.runResult)  ? 
                  'orangered' : ''
              }}>
                {
                  runState.value.state?.latestExecutionLog?.runResult === JOB_RUN_RESULT.SUCCESS.CODE ?
                  JOB_RUN_RESULT.SUCCESS.NAME :
                  runState.value.state?.latestExecutionLog?.runResult === JOB_RUN_RESULT.ERROR.CODE ?
                  JOB_RUN_RESULT.ERROR.NAME :
                  runState.value.state?.latestExecutionLog?.runResult === JOB_RUN_RESULT.FAILED.CODE ?
                  JOB_RUN_RESULT.FAILED.NAME : '-'
                }
              </span>
            </div>
            <div class={ JobCssModule.runStateList }>
              <span class={ JobCssModule.runStateTitle }>开始时间</span><span>
                { runState.value.state?.latestExecutionLog?.startRunTime || '-' }
              </span>
            </div>
            <div class={ JobCssModule.runStateList }>
              <span class={ JobCssModule.runStateTitle }>结束时间</span><span>
                { runState.value.state?.latestExecutionLog?.endRunTime || '-' }
              </span>
            </div>
          </div>
        </div>
      </Popover>
    ),
    { width: '120' }
  ),
  createTableColumnSlot(
    '状态',
    row => h(
      <ElSwitch 
        v-model={ row.status } 
        disabled={ row.statusDisabled }
        active-value={ JOB_STATUS.ENABLED.CODE }
        inactive-value={ JOB_STATUS.DISABLED.CODE }
        onChange={ () => { handleUpdateStatus(row) } }
      />
    ),
    { width: '80' }
  ),
  createTableColumn('创建时间', 'createdAt', '140', 'center', { sortable: true }),
  createTableColumn('操作', undefined, '250', 'center', {
    controller: [
      createTableActionItem('执行', 'Edit', (row) => {
        warningBox(`是否确认运行一次${row.jobName}？`).then(() => {
          trigger(row.id).then(() => {
            toast.success('运行成功')
            tb.load(searchData.value)
          })
        })
      }),
      tableEditController((row) => {
        editForm.open(row.id)
      }),
      tableDeleteController((row) => {
        deleteBox().then(() => {
          remove([row.id]).then(() => {
            toast.success('删除成功')
            tb.load(searchData.value)
          })
        })
      }),
      createTableActionItem('日志', 'Edit', (row) => {
        jobName.value = row.jobName
        logDialog.open(row.id)
      }),
    ]
  }),
]

const headerButtons = [
  tableAddHeader(() => {
    addForm.open()
  }),
  tableEditHeader((rows: any[]) => {
    if(isOnlyOne(rows)) {
      editForm.open(rows[0].id)
    }
  }),
  tableDeleteHeader((rows: any[]) => {
    if(isOnlyOne(rows)) {
      deleteBox().then(() => {
        remove(rows.map(item => item.id)).then(() => {
          toast.success('删除成功')
          tb.load(searchData.value)
        })
      })
    }
  })
]

function getNextSchedule(cron: string) {
  const interval = CronParser.parseExpression(cron)
  if (!interval.hasNext()) {
    return ''
  }
  return Moment(interval.next().toDate()).format('YYYY-MM-DD HH:mm:ss')
}

function handleUpdateStatus(data: any) {
  data.statusDisabled = true
  updateStatus(data).then(() => {
    if (data.status === JOB_STATUS.ENABLED.CODE) {
      toast.success('任务已启用')
    } else if (data.status === JOB_STATUS.DISABLED.CODE) {
      toast.success('任务已停用，如果任务正在运行，则会在本轮运行结束后完全停止')
    }
  }).catch(() => {
    if (data.status === JOB_STATUS.ENABLED.CODE) {
      data.status = JOB_STATUS.DISABLED.CODE
    } else {
      data.status = JOB_STATUS.ENABLED.CODE
    }
  }).finally(() => {
    data.statusDisabled = false
  })
}

function handleRunStateShow(row: any) {
  runState.value.showing = true
  if (!runState.value.showing) {
    return
  }
  if (runState.value.refreshing) {
    runState.value.currentJob = row
    return
  }
  runState.value.refreshing = true
  const loading = ElLoading.service({
    target: runStateEl.value
  })

  state(row.id).then(result => {
    runState.value.state = result.data
    row.runState = result.data.runState
  }).finally(() => {
    loading.close()
    if (runState.value.currentJob &&
      runState.value.currentJob.id !== row.id) {
      runState.value.refreshing = false
      handleRunStateShow(runState.value.currentJob)
    } else {
      runState.value.currentJob = null
      runState.value.refreshing = false
    }
  })
}

function renderRunState(runState: any) {
  if(runState.state.runState === JOB_RUN_STATE.RUNNING.CODE) {
    return (
      <div>
        <div class={JobCssModule.runStateList }>
          <span class={ JobCssModule.runStateTitle }>状态</span><span style="color: limegreen">
            { JOB_RUN_STATE.RUNNING.NAME }
          </span>
        </div>
        <div class={ JobCssModule.runStateList }>
          <span class={ JobCssModule.runStateTitle }>开始时间</span><span>
            { runState.state.latestStartRunTime || '-' }
          </span>
        </div>
      </div>
    )
  } else if(runState.state.runState===JOB_RUN_STATE.PENDING.CODE) {
    return (
      <div>
        <div class={ JobCssModule.runStateList }>
          <span class={ JobCssModule.runStateTitle }>状态</span><span style="color: dodgerblue">
            { JOB_RUN_STATE.PENDING.NAME }
          </span>
        </div>
        <div class={ JobCssModule.runStateList }>
          <span class={ JobCssModule.runStateTitle }>计划下次</span><span>
            { runState.state.scheduledNextRunTime || '-' }
          </span>
        </div>
      </div>
    )
  } else if(runState.state.runState===JOB_RUN_STATE.STOPPED.CODE) {
    return (
      <div class={ JobCssModule.runStateList }>
        <span class={ JobCssModule.runStateTitle }>状态</span><span style="color: orangered">
          { JOB_RUN_STATE.STOPPED.NAME }
        </span>
      </div>
    )
  } else {
    return <div></div>
  }
}